import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NotificationsModule } from "src/app/shared/notifications/notifications.module";
import { SfcLandingComponent } from "./sfc-landing.component";
import { InputSwitchModule } from "primeng/inputswitch";
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { AvatarGroupModule } from 'primeng/avatargroup';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { InputTextareaModule } from "primeng/inputtextarea";
import { StyleClassModule } from "primeng/styleclass";
import { LayoutModule } from "src/app/layout/layout.module";
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';



@NgModule({
    declarations: [SfcLandingComponent],
    exports: [SfcLandingComponent],
    imports: [
        CommonModule,
        FormsModule,
        NotificationsModule,
        InputSwitchModule,
        AvatarModule,
        ButtonModule,
        InputTextModule,
        MenuModule,
        AvatarGroupModule,
        TagModule,
        RippleModule,
        LayoutModule,


    InputTextareaModule,
    StyleClassModule,
    AccordionModule,
    CardModule,
    DividerModule,

    ],
    //providers: [ScArchiveTypeService]
})
export class SfcLandingModule {}
